import React, { useEffect, useState } from "react";
import Colors from "../components/Colors";
import { Box, Typography } from "@mui/material";
import Header from "../components/Header";
import WinnersListSlider from "../components/WinnersList";
import SnowordBanner from "../components/SnowordBanner";
import "../css/CountDownPage.css";
import Footer from "../components/Footer";
import CountDownTimer from "../components/CountDownTimer";
import axios from "axios";
import { API_URL } from "../components/Constant";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

function WaitingRoom() {
  const [showContent, setShowContent] = useState(true);
  const [countdown, setCountdown] = useState(5);
  const [targetTime, setTargetTime] = useState(null);
  const [gameId, setGameId] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [winnersList, setWinnersList] = useState([]);

  // const targetTime = new Date('2025-02-29T11:00:00');
  const targetDate = new Date("2024-03-10T00:00:00");

  const location = useLocation();
  const [prevPath, setPrevPath] = useState("");

  useEffect(() => {
    const prevPath = sessionStorage.getItem("prevPath");
    console.log(prevPath);
    if (prevPath === "/waiting-room") {
      localStorage.removeItem("playDemoDate");
    }

    sessionStorage.setItem("prevPath", location.pathname); // Update previous path
  }, [location.pathname]);

  useEffect(() => {
    const fetchPublishingTime = async () => {
      try {
        const gameCategory = localStorage.getItem("RapidGame");
        if (!gameCategory) return;
        console.log("gameCategory", gameCategory);
        const response = await axios.get(
          `${API_URL}/get_rapid_game_details?category=${gameCategory}`,
        );

        if (response.data && response.data.publishing_time) {
          setTargetTime(new Date(response.data.publishing_time)); // Convert string to Date
          localStorage.setItem("PublishingTime", response.data.publishing_time);
        }
      } catch (error) {
        console.error("Error fetching game details:", error);
      }
    };

    fetchPublishingTime();
  }, []);

  const [playerScore, setPlayerScore] = useState(null);
  useEffect(() => {
    const fetchGameScoreData = async () => {
      try {
        const response = await axios.post(
          `${API_URL}/player_score_rapid_riddle`,
          {
            PlayerTocken: localStorage.getItem("PlayerTocken"),
            gameCategory: localStorage.getItem("RapidGame"),
          },
        );
        setPlayerScore(response.data.totalScore);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchGameScoreData();
    const intervalId = setInterval(fetchGameScoreData, 1000);

    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    if (!targetTime) return; // Prevent running until targetTime is set

    const interval = setInterval(() => {
      const currentTime = new Date();
      const timeDifference = targetTime - currentTime;

      if (timeDifference <= 300000 && timeDifference > 5000) {
        setShowContent(true);
      } else if (timeDifference <= 5000 && timeDifference > 0) {
        setShowContent(false);
        setCountdown(Math.ceil(timeDifference / 1000));
      } else if (timeDifference <= 0) {
        // Store a flag in sessionStorage when the countdown reaches 0
        sessionStorage.setItem("gameUnlocked", "true");
        window.location.href = "/rapid-riddle-game"; // Redirect to the game
      }
    }, 1000);

    return () => clearInterval(interval);
  }, [targetTime]);
  const navigate = useNavigate();

  useEffect(() => {
    // Check if the game was unlocked via the waiting room
    if (!sessionStorage.getItem("gameUnlocked")) {
      navigate("/waiting-room"); // Redirect to the waiting room if accessed directly
    }
  }, [navigate]);
  useEffect(() => {
    const fetchPublishingTime = async () => {
      try {
        const gameCategory = localStorage.getItem("RapidGame");
        const response = await axios.get(
          `${API_URL}/get_rapid_game_details?category=${gameCategory}`,
        );

        console.log(response.data);
        if (response.data && response.data.publishing_time) {
          setTargetTime(new Date(response.data.publishing_time));
          // setTargetTime(response.data.publishing_time);
          localStorage.setItem("PublishingTime", response.data.publishing_time);
        }
      } catch (error) {
        console.error("Error fetching game details:", error);
      } finally {
        setIsLoading(false); // Set loading to false after fetching
      }
    };

    fetchPublishingTime();
  }, []);

  if (isLoading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          background: Colors.bgColor,
        }}
      >
        <Typography variant="h4">Loading...</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        gap: "8px",
        background: Colors.bgColor, // Dark blue gradient
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        fontFamily: "Poppins, sans-serif", // Modern font
      }}
    >
      {showContent ? (
        <>
          <Box sx={{ width: "100%", zIndex: 101, position: "relative" }}>
            <Header />
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              height: { md: "100px", xs: "90px" },
              maxWidth: { xs: "92%", md: "92%" },
              justifyContent: "center",
              alignItems: "center",
              background: Colors.Tidesbg,
              borderRadius: "8px",
              overflow: "hidden",
              // marginTop:{xs:'5%', md:'2.5%'},
              borderColor: "#EACABB",
            }}
          >
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: { xs: "20px", md: "32px" },
                color: "#000",
                textAlign: "center",
                fontFamily: "Boogaloo",
              }}
            >
              Hello, {localStorage.getItem("PlayerName")}
            </Typography>
            <Typography
              sx={{
                fontWeight: 500,
                fontSize: { xs: "16px", md: "20px" },
                color: "#000",
                textAlign: "center",
                fontFamily: "Boogaloo",
              }}
            >
              You scored {playerScore ? playerScore : 0} points in the{" "}
              {localStorage.getItem("RapidGame")} special Rapid Riddle.
            </Typography>
          </Box>

          {/* Main Content Container */}
          <Box
            sx={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              gap: { md: "32px", xs: "40px" },
              alignItems: "center",
              py: 4, // Add vertical padding
            }}
          >
            {/* Snoword Banner */}
            <Box sx={{ width: "100%" }}>
              <SnowordBanner />
            </Box>

            {/* Game Starting Soon Text and Countdown Timer */}
            <Box
              sx={{
                width: "90%",
                textAlign: "center",
                mt: 3,
                mb: 2,
                maxWidth: "90%",
                background: Colors.Tidesbg,
                paddingTop: "2.5%",
                paddingBottom: "2.5%",
                border: Colors.button2Border,
                borderRadius: "16px",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  fontWeight: "700",
                  fontFamily: "Boogaloo",
                  color: "#000", // Attractive red-orange color
                  textShadow: "2px 2px 6px rgba(0,0,0,0.2)",
                  letterSpacing: "1px",
                  mb: 3,
                  fontSize: { xs: "1.75rem", md: "2.5rem" }, // Responsive font size
                }}
              >
                The Game is About to Start!
              </Typography>

              {/* Countdown Timer */}

              <Box
                sx={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                  mb: 4,
                }}
              >
                {targetTime ? (
                  <CountDownTimer targetDate={targetTime} />
                ) : (
                  <p>Loading countdown...</p>
                )}
              </Box>
            </Box>

            {/* Winners List Slider */}
            <Box
              sx={{
                width: "100%",
                height: "100%",
                paddingTop: "2%",
                paddingBottom: "2%",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <WinnersListSlider />
            </Box>
          </Box>

          {/* Footer */}
          <Footer />
        </>
      ) : (
        <Box
          sx={{
            display: "flex",
            width: "100%",
            minWidth: "100%",
            justifyContent: "center",
            alignItems: "center",
            minHeight: "100vh",
            background: "linear-gradient(135deg, #0A0F1F, #1A1A2E)", // Dark blue gradient
          }}
        >
          <Typography
            variant="h1"
            sx={{
              fontWeight: 700,
              minWidth: { md: "100vw", xs: "80vw" },
              textAlign: "center",
              color: "#ff6f61",
              textShadow: "2px 2px 6px rgba(0,0,0,0.2)",
              fontSize: { xs: "84px", md: "175px" },
              animation: "zoomOut 1s ease-in-out infinite",
              "@keyframes zoomOut": {
                "0%": {
                  transform: "scale(1.5)",
                  opacity: 1,
                },
                "50%": {
                  transform: "scale(1)",
                  opacity: 1,
                },
                "100%": {
                  transform: "scale(1.5)",
                  opacity: 1,
                },
              },
            }}
          >
            {countdown}
          </Typography>
        </Box>
      )}
    </Box>
  );
}

export default WaitingRoom;
